import {
	Button,
	Card,
	CardContent,
	CardHeader,
	TextField,
	Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { AddOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import React from 'react'

import useCurrentUser from '../../../hooks/useCurrentUser'
import { MainButton } from '../../'

const useStyles = makeStyles((theme) => ({
	fieldWrapper: {
		'& .MuiTextField-root': { width: '100%', minWidth: '100%' }
	},
	sectionTitle: {
		fontWeight: 800,
		fontSize: 16,
		marginBottom: 16,
		marginTop: 8
	},
	hoursRow: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr auto',
		gridGap: '16px',
		alignItems: 'flex-start',
		marginBottom: '16px'
	},
	fullWidth: {
		marginBottom: '23px'
	}
}))

const ClientAppContent = ({ selectedFacility, setCurrent }) => {
	const classes = useStyles()
	const { isBackOfficeUser } = useCurrentUser()

	if (!isBackOfficeUser) {
		return null
	}

	const disabled = !selectedFacility.active
	const hoursRows = selectedFacility.hours_rows || []

	const updateField = (field, value) => {
		setCurrent({ ...selectedFacility, [field]: value })
	}

	const updateHoursRow = (index, field, value) => {
		const updated = hoursRows.map((row, rowIndex) =>
			rowIndex === index ? { ...row, [field]: value } : row
		)
		updateField('hours_rows', updated)
	}

	const addHoursRow = () => {
		updateField('hours_rows', [...hoursRows, { left_text: '', right_text: '' }])
	}

	const removeHoursRow = (index) => {
		updateField(
			'hours_rows',
			hoursRows.filter((_, rowIndex) => rowIndex !== index)
		)
	}

	return (
		<Card style={{ maxWidth: '1245px', marginTop: 24 }}>
			<CardHeader
				title="Client App Content"
				subheader="Fields displayed in the client mobile app that are not editable elsewhere in admin."
			/>
			<CardContent>
				<Typography className={classes.sectionTitle}>Hours of Operation</Typography>
				<Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
					Shown on check-in screens in the client app.
				</Typography>

				{hoursRows.map((row, index) => (
					<div key={`hours-row-${index}`} className={classes.hoursRow}>
						<TextField
							label="Hours Label"
							variant="filled"
							value={row.left_text || ''}
							disabled={disabled}
							onChange={(e) => updateHoursRow(index, 'left_text', e.target.value)}
						/>
						<TextField
							label="Hours Value"
							variant="filled"
							value={row.right_text || ''}
							disabled={disabled}
							onChange={(e) => updateHoursRow(index, 'right_text', e.target.value)}
						/>
						<Button
							color="secondary"
							disabled={disabled}
							onClick={() => removeHoursRow(index)}
							style={{ marginTop: 8 }}>
							Delete
						</Button>
					</div>
				))}

				<MainButton
					label="Add Hours Row"
					startIcon={<AddOutlined />}
					disabled={disabled}
					onClick={addHoursRow}
					style={{ marginBottom: 24 }}
				/>

				<Typography className={classes.sectionTitle}>URLs</Typography>
				<div className={clsx([classes.fieldWrapper, classes.fullWidth, 'field-wrapper'])}>
					<TextField
						label="Menu URL"
						variant="filled"
						value={selectedFacility.menu_url || ''}
						disabled={disabled}
						onChange={(e) => updateField('menu_url', e.target.value)}
					/>
				</div>
				<div className={clsx([classes.fieldWrapper, classes.fullWidth, 'field-wrapper'])}>
					<TextField
						label="Events Calendar URL"
						variant="filled"
						value={selectedFacility.events_calendar_url || ''}
						disabled={disabled}
						onChange={(e) => updateField('events_calendar_url', e.target.value)}
					/>
				</div>
				<div className={clsx([classes.fieldWrapper, classes.fullWidth, 'field-wrapper'])}>
					<TextField
						label="Bar Menu URL"
						variant="filled"
						value={selectedFacility.bar_menu_url || ''}
						disabled={disabled}
						onChange={(e) => updateField('bar_menu_url', e.target.value)}
					/>
				</div>
			</CardContent>
		</Card>
	)
}

export default ClientAppContent
